import React, { useState } from "react";
import { CustomInputText } from "../../CustomInputText";
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { useForm, Controller } from "react-hook-form";
import { CustomInputSwitch } from "../../CustomInputSwitch";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const UpdateServiceForm = (props) => {

    const { data, action } = props;
    const [activo, setActivo] = useState(data?.activo ? 'Activo' : 'Inactivo');
    const { handleSubmit, control, formState: { errors } } = useForm();

    return (
        <form style={{ margin: '30px 30px 20px 30px', position: 'relative',  width: 420 }} onSubmit={ handleSubmit(action) }>
            <div style={{ height: '60%' }}>

                <Controller 
                    name='servicio'
                    control={ control }
                    defaultValue={ convertirLetraMayus(data?.servicio) || '' }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputText
                            label="Servicio"
                            placeholder="abc"
                            error={ errors?.servicio } 
                            onChange={ onChange }
                            value={ value }
                        />
                    )}
                    
                    rules={{ 
                        required: 'El campo es obligatorio.'
                    }}
                />

                <Controller 
                    name='activo'
                    control={ control }
                    defaultValue={ data?.activo || false }
                    render={({ field: { onChange, value } }) => (
                        <CustomInputSwitch
                            label={ activo }
                            onChange={ (e) => {
                                console.log(e.target.checked);
                                onChange(e);
                                e.target.checked ? setActivo('Activo') : setActivo('Inactivo');
                            }}
                            value={ value }
                        />
                    )}
                />
            </div>

            <CustomButtonsForm name='Actualizar' />
        </form>
    );
};